import { useState, useEffect } from "react";
import { RiArrowDropDownLine } from "react-icons/ri";
import { PERMIKA_TEAM } from "../../../shared/data/team";
import { useYear } from "../About";
import { POSSIBLE_YEARS } from "../../../shared/data/team";

export const Team = () => {
    const { currentYear, setCurrentYear } = useYear();
    const teamData = PERMIKA_TEAM[POSSIBLE_YEARS[currentYear]];

    const [currentDepartment, setCurrentDepartment] =
        useState<string>(teamData.departmentsList[0]);
    
    const [isHovering, setIsHovering] = useState(false);
    const [mobileDeptOpen, setMobileDeptOpen] = useState(false);

    useEffect(() => {
        // reset to first department when year changes
        setCurrentDepartment(teamData.departmentsList[0]);
        setMobileDeptOpen(false);
    }, [currentYear, teamData.departmentsList]);

    return (
        <div className="min-h-screen bg-white text-black flex flex-col items-center justify-center">
            <div className="w-full flex justify-center mt-10 mb-6">
                <div
                    className="relative text-[#CC7200] hover:cursor-pointer"
                    onMouseEnter={() => setIsHovering(true)}
                    onMouseLeave={() => setIsHovering(false)}
                >
                    <h1 className="flex text-3xl md:text-4xl font-medium">
                        {POSSIBLE_YEARS[currentYear]}
                        <RiArrowDropDownLine className="pt-2 text-4xl" />
                    </h1>

                    {isHovering && (
                        <div className="absolute bg-white rounded-md overflow-hidden z-10 w-full text-center space-y-1 shadow-md">
                            {POSSIBLE_YEARS.map((year, index) => (
                                <button
                                    key={year}
                                    onClick={() => {
                                        setCurrentYear(index);
                                        setIsHovering(false);
                                    }}
                                    className="block w-full py-2 text-lg text-gray-700 bg-gray-100 hover:bg-[#CC7200] hover:text-white"
                                >
                                    {year}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <div className="w-11/12 md:w-4/5 lg:w-2/3 flex flex-col md:flex-row gap-6 md:gap-8">
                {/* Departments list */}
                {/* Mobile dropdown */}
                <div className="md:w-2/5 md:hidden relative mt-8 w-full flex flex-col items-center">
                    <p className="mb-2 text-xs font-medium uppercase tracking-wide text-grey-body text-center">View department</p>
                    <button
                        type="button"
                        onClick={() => setMobileDeptOpen((o) => !o)}
                        className="inline-flex justify-between items-center py-2 px-4 rounded-md border border-gray-300 shadow-sm bg-white hover:bg-amber-50 gap-x-4 w-auto min-w-[12rem]"
                        aria-haspopup="listbox"
                        aria-expanded={mobileDeptOpen}
                    >
                        <span className="flex-1 text-left text-black-text">{currentDepartment}</span>
                        <svg
                            className={`h-5 w-5 text-grey-body transform transition-transform duration-200 ${mobileDeptOpen ? "rotate-180" : "rotate-0"}`}
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                        >
                            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.095l3.71-3.864a.75.75 0 011.08 1.04l-4.24 4.41a.75.75 0 01-1.08 0L5.25 8.27a.75.75 0 01-.02-1.06z" clipRule="evenodd" />
                        </svg>
                    </button>
                    {mobileDeptOpen && (
                        <div className="absolute z-10 mt-2 w-56 bg-white border border-gray-200 rounded-md shadow-md overflow-hidden left-1/2 -translate-x-1/2">
                            <ul role="listbox" className="max-h-64 overflow-y-auto">
                                {teamData.departmentsList.map((dep) => (
                                    <li
                                        key={dep}
                                        role="option"
                                        aria-selected={dep === currentDepartment}
                                        className={`px-4 py-2 text-sm ${dep === currentDepartment ? "bg-amber-50 text-black" : "text-gray-700 hover:bg-gray-50"}`}
                                        onClick={() => { setCurrentDepartment(dep); setMobileDeptOpen(false); }}
                                    >
                                        {dep}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>

                {/* Desktop/Tablet list */}
                <div className="w-full md:w-2/5 py-8 md:py-16 hidden md:flex md:flex-col justify-start md:justify-center text-lg md:text-xl font-light 
                                md:space-y-4">

                    {teamData.departmentsList.map((item, i) => (
                        <p
                            role="button"
                            onClick={() => setCurrentDepartment(item)}
                            key={i}
                            className={`${item === currentDepartment ? "font-bold text-black" : "text-gray-400"} 
                                        shrink-0 cursor-pointer`}
                        >
                            {item}
                        </p>
                    ))}
                </div>
                {/* Right content */}
                <div className="w-full md:w-3/5 py-8 md:py-16 px-0 sm:px-4 md:px-8">
                    <div>
                        <img
                            src={teamData.department[currentDepartment]}
                            alt="Core Team"
                            className="aspect-[16/15] w-full max-w-2xl object-cover rounded-md"
                        />
                    </div>
                    <div className="mt-6 md:mt-10">
                        <div className="flex items-center gap-3 md:gap-4 mb-4 md:mb-6 w-full">
                            <h2 className="text-xl md:text-2xl whitespace-nowrap">{currentDepartment} Team</h2>
                            <div className="flex-grow h-[2px] bg-green-800" />
                        </div>

                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4 text-sm">
                            {teamData.departmentMember.filter(el => el.department === currentDepartment).map((member, index) => (
                                <div key={index}>
                                    <p className="font-medium">
                                        {member.name}{" "}
                                    </p>
                                    <p className="text-gray-500 text-sm">{member.role}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div></div>
    )
}